export default "__VITE_ASSET__44b5b705__"